module.exports = __webpack_public_path__ + "img/2.2e518ca5.jpg";